import React from 'react'
import Link from 'gatsby-link'

import PageHeader from '../__components/PageHeader'
import PAGE_HEADER from '../img/pageheaders/services_fc.jpg'

import ShareButtons from '../__components/ShareButtons'

const pageMeta = {
  title: "Free Consultation",
};
const AboutPage = ({ transition }) => (
  <div style={transition && transition.style} className="page">
    <PageHeader bgPhoto={PAGE_HEADER} cover={true} styles={{ backgroundColor: "#747173" }} />

    {typeof window !== 'undefined' &&
      <ShareButtons location={location.href} desc={pageMeta.desc} />
    }

    <div className="container">
      <div className="title-bar">
        <h1>{pageMeta.title}</h1>
        <p>{pageMeta.desc}</p>
      </div>

      <p>
      Many patients choose to have treatments performed on the day of their consultation.  If you would like to have treatment on the same day as the initial consultation, please make sure to schedule accordingly.  Please make sure that all of your questions are answered to your satisfaction prior to receiving treatment.  On the day of your consultation, wash your face thoroughly with antibacterial soap and do not apply foundation or other makeup to the area which is being treated.  These consultations are complimentary.
      </p>
    </div>
  </div>
)

export default AboutPage



// WEBPACK FOOTER //
// ./src/pages/services-free-consultation.js